// Team-based permissions: check if agent is in a resource's owning teams
export const hasTeamOwnershipAccess = (
  owningTeamIds: number[] | null | undefined,
  agentTeamIds: number[],
  featureFlagEnabled: boolean,
  hasEditAllWorkflowsPermission: boolean = false,
): boolean => {
  // If feature flag is off, all agents can access
  if (!featureFlagEnabled) {
    return true;
  }
  // Agents with edit:all_workflows permission bypass team-based restrictions
  if (hasEditAllWorkflowsPermission) {
    return true;
  }
  // If owningTeamIds is null/undefined, all teams can access
  if (owningTeamIds == null) {
    return true;
  }
  // If owningTeamIds is empty, no teams can access
  if (owningTeamIds.length === 0) {
    return false;
  }
  // Check if any of the agent's teams are in the owning teams
  return agentTeamIds.some((teamId) => owningTeamIds.includes(teamId));
};
